export default () => ({
  open: false,
  heightSet: false,
  variants: [],
  variantId: null,
  productId: null,
  activeButton: null,
  email: null,
  checked: false,
  error: false,
  checkboxError: false,
  notified: false,
  somethingWentWrong: false,
  product_id: null,
  collection_id: null,
  type: null,

  toggleChecked() {
    this.checked = !this.checked;
  },

  validateEmail(email) {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  },

  hide() {
    this.open = false;
    this.checked = false;
    this.email = null;
    this.error = false;
    this.checkboxError = false;
    setTimeout(
      () => ((this.notified = false), (this.somethingWentWrong = false)),
      300
    );
  },

  show(data) {
    this.product_id = data.product_id;
    this.collection_id = data.collection_id;
    this.type = data.type;

    const title = data.notifyMeText || data.product_title;

    document.getElementById("notifyMeHeading").innerHTML = title;

    this.open = true;
  },

  setVariantId(id) {
    this.variantId = id;
  },

  setActiveButton(button) {
    this.activeButton = button;
  },

  submit() {
    if (this.type === "product") {
      //Product post
      if (this.validateEmail(this.email) && this.checked) {
        fetch(`${shopUrl}/apps/jl-api/frontend/alert/release`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            product_id: this.product_id,
            email: this.email,
            country_code: Shopify.country,
            language_code: Shopify.locale,
          }),
        })
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            //console.log(response);
            if (response.errors) {
              this.displayErrorMessage();
            } else {
              this.displayResultMessage();
            }
          });
      } else {
        if (!this.checked) this.checkboxError = true;
        if (!this.validateEmail(this.email)) this.error = true;
      }
    } else if (this.type === "collection") {
      //Collection post
      if (this.validateEmail(this.email) && this.checked) {
        fetch(`${shopUrl}/apps/jl-api/frontend/alert/release`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            collection_id: this.collection_id,
            email: this.email,
            country_code: Shopify.country,
            language_code: Shopify.locale,
          }),
        })
          .then((response) => {
            return response.json();
          })
          .then((response) => {
            //console.log(response);
            if (response.errors) {
              this.displayErrorMessage();
            } else {
              this.displayResultMessage();
            }
          });
      } else {
        if (!this.checked) this.checkboxError = true;
        if (!this.validateEmail(this.email)) this.error = true;
      }
    }
  },

  displayResultMessage() {
    this.open = false;

    // hide form content
    // show result content
    this.notified = true;

    // delay 300ms
    // open true
    setTimeout(() => (this.open = true), 300);
  },

  displayErrorMessage() {
    this.open = false;
    this.somethingWentWrong = true;
    setTimeout(() => (this.open = true), 300);
  },

  toggleBodyClass(addBodyClass) {
    let body = document.querySelector("body");
    if (addBodyClass) {
      if (!body.classList.contains("modal-open")) {
        body.classList.add("modal-open");
      }
    } else {
      body.classList.remove("modal-open");
    }
  },
});
